import { useMemo } from "react";
import { WhoamiGroup } from "Types";

type UseBelongsToGroupProps = {
  groupId?: string;
  groups?: WhoamiGroup[];
};

type UseBelongsToGroup = {
  belongsToGroup: boolean;
  group?: WhoamiGroup;
};

const useBelongsToGroup = ({
  groupId,
  groups,
}: UseBelongsToGroupProps): UseBelongsToGroup => {
  const belongsToGroup = useMemo(
    () =>
      groupId && groups
        ? groups?.some(
            (group) => group.group_id === groupId && group.user_belongs,
          )
        : true,
    [groups, groupId],
  );

  const group = useMemo(
    () => groups?.find((group) => group.group_id === groupId),
    [groups, groupId],
  );

  return {
    belongsToGroup,
    group,
  };
};

export default useBelongsToGroup;
